import {createContext, useContext} from "react";

export const initialShopContextValues = {
  shopNavItems: [],
  shopAllNavItems: [],
  shopNavItemsLoaded: false,
  shopActiveCategory: "",
  shopActiveFeature: "",
  shopLastActiveFeature: "",
};

const shopAction = "CHANGE_SHOP_CONTEXT";

const ShopContext = createContext({});

export const useShopContext = () => {
  return useContext(ShopContext);
}

export const shopContextAction = (payload) => {
  return {
    type: shopAction,
    payload
  }
}

export const shopContextReducer = (state = initialShopContextValues, action) => {
  switch (action.type) {
    case shopAction:
      return {...state, ...action.payload};
    default:
      return state
  }
}

export default ShopContext;
